import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Teleport as _Teleport } from "vue"

const _hoisted_1 = { class: "order-container" }
const _hoisted_2 = {
  key: 0,
  class: "font-weight-600 p-2 m-0"
}
const _hoisted_3 = { class: "order-container__form" }
const _hoisted_4 = { class: "d-flex flex-column" }
const _hoisted_5 = { class: "d-flex checkbox-company" }
const _hoisted_6 = {
  class: "font-big font-weight-400 check-box-label",
  for: "isCompanyOrder"
}
const _hoisted_7 = { class: "d-flex flex-column order-3" }
const _hoisted_8 = { class: "d-flex checkbox-rule-agreement order-4" }
const _hoisted_9 = { class: "font-big font-weight-400 check-box-label" }
const _hoisted_10 = {
  for: "isRuleAgreement",
  class: "ms-0 me-1"
}
const _hoisted_11 = {
  class: "rule-agreement",
  "data-bs-toggle": "modal",
  "data-bs-target": "#purchaseDeclarationModal",
  href: "#",
  target: "_blank"
}
const _hoisted_12 = { class: "font-small order-4 error-color" }
const _hoisted_13 = { class: "rule-agreement-modal d-flex justify-content-center" }
const _hoisted_14 = { class: "company-form d-flex justify-content-center" }
const _hoisted_15 = { class: "company-form__container d-flex flex-column align-items-center col-9" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CheckBoxComponent = _resolveComponent("CheckBoxComponent")!
  const _component_InputComponent = _resolveComponent("InputComponent")!
  const _component_UserWrapperComponent = _resolveComponent("UserWrapperComponent")!
  const _component_OrderPaymentDataWrapperComponent = _resolveComponent("OrderPaymentDataWrapperComponent")!
  const _component_ButtonComponent = _resolveComponent("ButtonComponent")!
  const _component_ModalComponent = _resolveComponent("ModalComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (!this.store.getters['customer/isLoggedIn'])
        ? (_openBlock(), _createElementBlock("h5", _hoisted_2, _toDisplayString(_ctx.$t('responsible_person_info')), 1))
        : _createCommentVNode("", true),
      _createElementVNode("form", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (!this.store.getters['customer/isLoggedIn'])
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.inputs, (input) => {
                  return (_openBlock(), _createElementBlock(_Fragment, null, [
                    (input.key === 'isCompanyOrder')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("div", _hoisted_5, [
                            _createVNode(_component_CheckBoxComponent, {
                              id: "isCompanyOrder",
                              name: "isCompanyOrder",
                              onOnClick: ($event: any) => {input.value = !input.value; input.value ? _ctx.onIsCompanyOrderToggle() : null;},
                              state: input.value
                            }, {
                              "checkbox-text": _withCtx(() => [
                                _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('buying_company')), 1)
                              ]),
                              _: 2
                            }, 1032, ["onOnClick", "state"])
                          ]),
                          (!input.validation.state)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: _normalizeClass([{'error-color': !input.validation.state}, "font-small"])
                              }, _toDisplayString(_ctx.$t(input.validation.message)), 3))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 256)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.inputs, (input) => {
                  return (_openBlock(), _createElementBlock(_Fragment, null, [
                    (input.dataType === _ctx.InputDataTypes.TEXT)
                      ? (_openBlock(), _createBlock(_component_InputComponent, {
                          key: 0,
                          "name-input": input.name,
                          "data-type": input.dataType,
                          placeholder: _ctx.$t(input.placeholder),
                          data: input.value,
                          "onUpdate:data": ($event: any) => ((input.value) = $event),
                          msg: input.validation
                        }, null, 8, ["name-input", "data-type", "placeholder", "data", "onUpdate:data", "msg"]))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 256))
              ], 64))
            : (_openBlock(), _createBlock(_component_UserWrapperComponent, { key: 1 })),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_OrderPaymentDataWrapperComponent, {
              data: {
            duration: _ctx.duration,
            distance: _ctx.distance,
            price: _ctx.price
          }
            }, null, 8, ["data"])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mainForm.inputs, (input) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
              (input.key === 'isRulesAgreement')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_component_CheckBoxComponent, {
                        onOnClick: ($event: any) => (input.value = !input.value),
                        state: input.value,
                        id: "isRuleAgreement",
                        name: "isRuleAgreement",
                        class: ""
                      }, {
                        "checkbox-text": _withCtx(() => [
                          _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('i_agree_with_the')), 1),
                            _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('rules_more')), 1)
                          ])
                        ]),
                        _: 2
                      }, 1032, ["onOnClick", "state"])
                    ]),
                    (!input.validation.state)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: _normalizeClass([{'error-color': !input.validation.state}, "font-small order-4"])
                        }, _toDisplayString(_ctx.$t(input.validation.message)), 3))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true)
            ], 64))
          }), 256)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mainValidationMessages, (prop, key) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
              (!prop.isValid)
                ? (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass([{'error-color': !prop.isValid}, "font-small order-4"]),
                    key: key
                  }, _toDisplayString(_ctx.$t(prop.message)), 3))
                : _createCommentVNode("", true)
            ], 64))
          }), 256)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.backendValidationErrors, (error) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.$t(error)), 1))
          }), 256)),
          (!_ctx.orderProcessing)
            ? (_openBlock(), _createBlock(_component_ButtonComponent, {
                key: 2,
                class: "order-form-submit-button order-4",
                onClick: _withModifiers(_ctx.orderSubmit, ["prevent"])
              }, {
                btnContent: _withCtx(() => [
                  _createTextVNode(_toDisplayString(! _ctx.isSimpleOrder ? _ctx.$t('pay_order') : _ctx.$t('order_order')), 1)
                ]),
                _: 1
              }, 8, ["onClick"]))
            : (_openBlock(), _createBlock(_component_ButtonComponent, {
                key: 3,
                class: "order-form-submit-button order-4",
                disabled: "disabled"
              }, {
                btnContent: _withCtx(() => _cache[0] || (_cache[0] = [
                  _createElementVNode("span", { class: "loader" }, null, -1)
                ])),
                _: 1
              }))
        ])
      ])
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(_component_ModalComponent, {
        "is-main-modal": false,
        "show-link": false,
        id: 'rule-agreement',
        "z-index-custom": 'z-index-custom-0',
        backdrop: 'custom-modal-backdrop-0',
        "body-overflow": 'body-overflow'
      }, {
        "body-content": _withCtx(() => [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("h5", null, _toDisplayString(_ctx.$t('rules')), 1)
          ])
        ]),
        _: 1
      })
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(_component_ModalComponent, {
        "is-main-modal": false,
        "show-link": false,
        id: 'buying-company',
        "z-index-custom": 'z-index-custom-0',
        backdrop: 'custom-modal-backdrop-0',
        "body-overflow": 'body-overflow'
      }, {
        "body-content": _withCtx(() => [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("h5", null, _toDisplayString(_ctx.$t('company_data')), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.companyForm.inputs, (input) => {
                return (_openBlock(), _createBlock(_component_InputComponent, {
                  class: "col-12",
                  "name-input": input.name,
                  "data-type": input.dataType,
                  placeholder: _ctx.$t(input.placeholder),
                  data: input.value,
                  "onUpdate:data": ($event: any) => ((input.value) = $event),
                  msg: input.validation
                }, null, 8, ["name-input", "data-type", "placeholder", "data", "onUpdate:data", "msg"]))
              }), 256)),
              _createVNode(_component_ButtonComponent, {
                id: "submitButtonCompany",
                class: "col-12 order-form-submit-button",
                onClick: _ctx.submitCompanyForm
              }, {
                btnContent: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('submit')), 1)
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ])
        ]),
        _: 1
      })
    ]))
  ], 64))
}